module.exports = __webpack_public_path__ + "1880b72186147ca62cd735b9729b5600.pdf";